import React from 'react';
import Header from 'cccisd-header';
import IconShoppingCart from 'cccisd-icons/cart';
import style from './style.css';

import wpUrl from '../../helpers/wpUrl';
const Fortress = window.cccisd.fortress;

const AppHeader = ({ className, noLogoLink }) => {
    const primaryNavLinks = [
        { url: wpUrl + '/#ServicesPort', label: 'Services', handle: 'services' },
        {
            url: wpUrl + '/research',
            label: 'Research',
            handle: 'research',
            children: [
                { url: wpUrl + '/research', label: 'Research', handle: 'researchresearch' },
                { url: wpUrl + '/grants', label: 'Funding', handle: 'funding' },
                {
                    url: wpUrl + '/article-publications',
                    label: 'Publications',
                    handle: 'publications',
                },
            ],
        },
        { url: '/products', label: 'Products', handle: 'products' },
        { url: wpUrl + '/case-studies', label: 'Case Studies', handle: 'casestudies' },
        { url: wpUrl + '/news', label: 'News', handle: 'news' },
        {
            url: wpUrl + '/about',
            label: 'About',
            handle: 'about',
            children: [
                { url: wpUrl + '/about-us', label: 'About', handle: 'aboutabout' },
                { url: wpUrl + '/staff', label: 'Staff', handle: 'staff' },
                { url: wpUrl + '/faq', label: 'FAQ', handle: 'faq' },
                {
                    url: wpUrl + '/advisory-board',
                    label: 'Advisory Board',
                    handle: 'advisoryboard',
                },
                { url: wpUrl + '/job-opportunities', label: 'Employment', handle: 'employment' },
            ],
        },
        { url: '/3c-resource-center', label: 'Resource Center' },
    ];

    const isUber = Fortress.user.acting.role.handle === 'uberadmin';
    if (isUber) {
        primaryNavLinks.push({ url: '/manage', label: 'Manage', handle: 'manage' });
    }

    return (
        <Header
            containerClassName={`${className} ${style.headerWrapper}`}
            logoClassName={style.logo}
            primaryNavLinks={primaryNavLinks}
            showHomeAction={false}
            showAdminAction={isUber}
            additionalIconLinks={[
                {
                    icon: IconShoppingCart,
                    url: wpUrl + '/cart',
                    handle: 'cart',
                },
            ]}
            {...(noLogoLink ? { logoLink: null } : { logoLink: wpUrl })}
        />
    );
};

AppHeader.defaultProps = {
    className: 'container-fluid',
};

export default AppHeader;
